import React, {useState, useEffect, useCallback, useContext} from 'react';
import {OverlayContext} from '../../contexts/OverlayContext';
import {useNavigate} from 'react-router-dom';
import styled from 'styled-components';
import {CDN} from '../../config';

import {BITTERSWEET, BORDER, OzContainer, OzRow, OzCol, OzCard, OzTable, OzProjectTag, OzButton, OzInput, OzTag} from "@ozwol/webui";

import AccountService from '../../services/AccountService';
import WebhooksService from '../../services/WebhooksService';
import ProjectsService from '../../services/ProjectsService';

import Meta from '../../components/Meta';
// import ModalError from '../../components/ModalError';
import PageHeader from '../../components/PageHeader';
import CardHeaderTitle from '../../components/CardHeaderTitle';
import HealthyWrapper from '../../components/HealthyWrapper';
import PromptedButton from '../../components/PromptedButton';

import ModalWebhook1 from './../../chunks/ModalWebhook1';
import ModalVerifyWebhook from './../../chunks/ModalVerifyWebhook';
import ModalRollWebhook from './../../chunks/ModalRollWebhook';

// import {OVERLAY_TIMEOUT_ERROR} from '../../config';
import {formatError} from '../../helpers';


const TableWrapper = styled.div`
  & table tr td{
    white-space: nowrap;
  }
  & table tr td:nth-child(1),
  & table tr td:nth-child(2),
  & table tr td:nth-child(3){
    word-break: break-all;
    white-space: unset;
  }
`;
const NoResult = styled.div`
  text-align: center;
  font-weight: bold;

  & > img{
  width: 40%;

`;
const Accordion = styled.div`
  font-size: 12px;

	& hr{
		border-top: 1px solid ${BORDER};
		margin: 15px 0px;
	}
`;
const AccordionDetailItem = styled.div`
  padding: 6px 0px;
`;
const AccordionButtons = styled.div`
  text-align: right;
`;



const Webhooks = ({refScrollerPage}) => {	
  const navigate = useNavigate(); 
  const {addOverlay, removeOverlay} = useContext(OverlayContext);
  const [list, setList] = useState(null);
  const [listProjects, setListProjects] = useState(null);

  const [fetchError, setFetchError] = useState(false);



  const getList = useCallback(() => {
    WebhooksService.list().then((response) => {
      setList(response.result);
    }).catch((error) => {
      setFetchError(formatError(error));
    });
  }, []);

  const deleteItem = useCallback((item) => {
    setList(null);
    WebhooksService.delete(item.uuid).then((response) => {
      getList();
    }).catch((error) => {
      setList(null);
      setFetchError(formatError(error));
    });
  }, [getList]);

  useEffect(() => {
    getList();
    ProjectsService.list().then((response) => {
      setListProjects(response);
    });
  }, [getList]); 

  useEffect(() => {
    AccountService.getUser().then((response) => {
      if(!response.currentPlan.apiAllowed){
				navigate("/not-authorized");
			}
    });
  }, [navigate]); 


  return (
    <OzContainer size="extra">
      <Meta title={"Webhooks"} />
      <PageHeader
        breadcrumbsIcon="webhook"
        breadcrumbsText={["Overview", "Webhooks"]}
        refScrollerPage={refScrollerPage}
      />
  
      
      <HealthyWrapper error={fetchError} loading={!list || !listProjects}>
        <OzRow>
          <OzCol>
            <OzCard
              headerLeft={
                <CardHeaderTitle 
                  title={"Webhooks"}
                />
              }
              headerSeparator={true}
              footerRight={<OzButton
                onClick={() => addOverlay({
                  reference: "webhook",
        					isCloseable: false,
                  content: <ModalWebhook1 
											item={null} 
											projects={listProjects}
											onSuccess={() => {
												getList();
												removeOverlay("webhook");
											}} 
										/>									
                })} 
                variant={"chetwodeblue"}
              >Add</OzButton>}
            >
              {list && list.length > 0 ?
                <>
                  <TableWrapper>
                    <OzTable
                      columns={[
                        "Active",
                        "Endpoint",
                        "Description",
                        "Projects",
                        "Events"
                      ]}
                      values={
                        list.map(item => ({
                          style: !item.active ? {
                            background: BITTERSWEET+"33",
                            backgroundHover: BITTERSWEET+"55"
                          } : {},
													id: item.uuid,
													accordion: <Accordion>
														<OzRow>
															<OzCol widthmd="1">
																<b>HMAC Code</b>
															</OzCol>
															<OzCol widthmd="7">
																<OzInput width="100%" copyable type="password" toggleVisibility disabled value={item.hmacKey} />
															</OzCol>
															<OzCol widthmd="4">
																<AccordionButtons>
																	<OzButton 
																		onClick={() => addOverlay({
																			reference: "webhook",
																			content: <ModalRollWebhook
																				item={item} 
																				onSuccess={() => {
																					getList();
																					removeOverlay("webhook");
																				}} 
																			/>
																		})}
																		noMinWidth={true}
																		variant="push-black"
																	>Roll HMAC</OzButton>
																	&nbsp;
																	<OzButton 
																		onClick={() => addOverlay({
																			reference: "webhook",
																			content: <ModalVerifyWebhook
																				item={item} 
																			/>
																		})}
																		noMinWidth={true}
																		variant="push-black"
																	>Test</OzButton>
																	&nbsp;
																	<OzButton 
																		onClick={() => addOverlay({
																			reference: "webhook",
																			content: <ModalWebhook1 
																				item={item} 
																				projects={listProjects}
																				onSuccess={() => {
																					getList();
																					removeOverlay("webhook");
																				}} 
																			/>
																		})}
																		noMinWidth={true}
																		variant="push-black"
																	>Edit</OzButton>
																	&nbsp;
																	<PromptedButton 
																		buttonVariant="push-bittersweet" 
																		buttonText={"Delete"} 
																		prompt="DELETE"
																		buttonNoMinWidth={true}
																		onConfirm={() => deleteItem(item)} 
																	/> 
																	
																</AccordionButtons>	
															</OzCol>	
														</OzRow>
														<hr/>
														<OzRow>
															<OzCol widthmd="4">
																<b>Projects</b><br/>
																{item && item.projectsUuid && item.projectsUuid.length > 0 ? 
																	(item.projectsUuid[0] === "*" ? 
																		"All" 
																	: 
																		item.projectsUuid.map(projectUuid => 
																			listProjects && listProjects.filter(val => val.uuid === projectUuid).length > 0 ?
																				listProjects.filter(val => val.uuid === projectUuid).slice(0,1).map(project =>
																					<OzProjectTag
																						direction="horizontal"
																						key={project.uuid}
																						name={project.name}
																						uuid={project.uuid}
																						color={project.color}
																					/>
																				)
																			: "-"
																		)
																	) 
																: "-"}
															</OzCol>
															<OzCol widthmd="2">
															</OzCol>	
															<OzCol widthmd="6">
																<b>Events</b><br/>
																{item && item.events && item.events.length > 0 ? 
																	item.events.map(event => 
																		<AccordionDetailItem key={event}>{event}<br/></AccordionDetailItem>
																	) 
																: "-"  }	
															</OzCol>	
														</OzRow>
													</Accordion>,
                          values: [
                            <OzTag variant={item.active ? "silvertree" : "bittersweet"}>{item.active ? "Yes" : "No"}</OzTag>,
                            item.endpoint,
                            item.description,
                            item && item.projectsUuid && item.projectsUuid.length > 0 ? 
                              (item.projectsUuid[0] === "*" ? 
                                "All" 
                              : 
                                item.projectsUuid.length
                              ) 
                            : "-",
                            item && item.events && item.events.length > 0 ? 
                              item.events.length
                            : "-"                            
                          ]
                        }))
                      }
                    />
                  </TableWrapper>
                </>
              : 
                <NoResult>
                  <img src={CDN + "console-assets/no-generic.svg"} alt="no webhooks" /><br/><br/>
                  There are no active Webhooks.<br/>
                  Click Add to get started.
                </NoResult>
              }   

            </OzCard>
          </OzCol>
        </OzRow>
      </HealthyWrapper>
    </OzContainer>
  );
}

export default Webhooks;
